"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var material_1 = require("@mui/material");

var style_1 = __importDefault(require("./style"));

function Select(props) {
  var nameOfTheKeyWithTheValue = props.nameOfTheKeyWithTheValue,
      nameOfTheKeyWithTheLabel = props.nameOfTheKeyWithTheLabel,
      concatLabel = props.concatLabel,
      placeholder = props.placeholder,
      value = props.value,
      onChange = props.onChange,
      name = props.name,
      data = props.data,
      error = props.error,
      campo = props.campo,
      variant = props.variant,
      helperText = props.helperText;
  return react_1["default"].createElement(material_1.FormControl, {
    css: name == 'provincia' ? style_1["default"].selectUbicacion : style_1["default"].select,
    error: error ? error : false
  }, react_1["default"].createElement(material_1.TextField, {
    select: true,
    label: placeholder,
    value: value,
    variant: variant,
    onChange: onChange,
    inputProps: {
      name: name
    }
  }, data.map(function (option) {
    var valueItem = option[nameOfTheKeyWithTheValue] !== undefined && option[nameOfTheKeyWithTheValue] !== null ? option[nameOfTheKeyWithTheValue] : option;
    var labelItem = (option[nameOfTheKeyWithTheLabel] !== undefined && option[nameOfTheKeyWithTheLabel] !== null ? option[nameOfTheKeyWithTheLabel] : option) + (concatLabel || '');
    return react_1["default"].createElement(material_1.MenuItem, {
      key: valueItem,
      value: valueItem
    }, labelItem);
  })), error ? react_1["default"].createElement(material_1.FormHelperText, null, "El campo ", campo, " es obligatorio") : null, helperText ? react_1["default"].createElement(material_1.FormHelperText, null, helperText) : null);
}

exports["default"] = Select;